export default __webpack_public_path__ + "static/media/objectsRain_responsive.0390dc39.png";